export const AUDIO_TURN_IDEMPOTENCY_HEADER = 'Idempotency-Key' as const;

export const SUPPORTED_AUDIO_NOTE_MIME_TYPES = [
  'audio/mpeg',
  'audio/mp4',
  'audio/m4a',
  'audio/webm',
  'video/webm',
  'audio/wav',
  'audio/x-wav',
  'audio/ogg',
] as const;

export const LIVE_AUDIO_STREAM_FORMATS = ['pcm_s16le', 'mp3'] as const;

export const FINALIZED_AUDIO_ASSET_MIME_TYPES = [
  'audio/mpeg',
  'audio/mp4',
  'audio/wav',
] as const;

export const AUDIO_NOTE_MAX_UPLOAD_BYTES = 25 * 1024 * 1024;
export const AUDIO_NOTE_MAX_DURATION_MS = 10 * 60 * 1000;

export type SupportedAudioNoteMimeType = typeof SUPPORTED_AUDIO_NOTE_MIME_TYPES[number];
export type LiveAudioStreamFormat = typeof LIVE_AUDIO_STREAM_FORMATS[number];
export type FinalizedAudioAssetMimeType = typeof FINALIZED_AUDIO_ASSET_MIME_TYPES[number];

export interface UploadedAudioNote {
  chatId?: string;
  turnId?: string;
  personaId: string;
  idempotencyKey?: string;
  fileName: string;
  mimeType: SupportedAudioNoteMimeType;
  byteLength: number;
  durationMs?: number;
}

export interface AudioAssetStorageLocation {
  url?: string;
  storageProvider?: 's3' | 'gcs' | 'local';
  storageBucket?: string;
  /** Optional partition prefix such as `2026/04/07/13/` for object storage layouts. */
  storagePrefix?: string;
  storageKey?: string;
  requiresSignedUrl?: boolean;
}

export interface StoredAudioAsset extends AudioAssetStorageLocation {
  assetId: string;
  mimeType: FinalizedAudioAssetMimeType;
  durationMs?: number;
  byteLength?: number;
  createdAt?: string;
}

export interface AudioTurnMetrics {
  uploadBytes?: number;
  uploadDurationMs?: number;
  transcriptionMs?: number;
  llmFirstTokenMs?: number;
  ttsFirstByteMs?: number;
  firstAudioChunkMs?: number;
  assetFinalizationMs?: number;
  totalTurnMs?: number;
}
